module.exports = __webpack_public_path__ + "static/img/10.602bfcc5.png";